import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import BalanceSheetTabs from './BalanceSheetTabs';
import BalanceSheetTabContent from './BalanceSheetTabContent';

const BalanceSheetContent = ({
  balanceSheetStepResource,
}) => {
  return (
    <FDStack direction={'column'} spacing={3}>
      <BalanceSheetTabs
        balanceSheetStepResource={balanceSheetStepResource}
      />
      <BalanceSheetTabContent
        balanceSheetStepResource={balanceSheetStepResource}
      />
    </FDStack>
  );
};

BalanceSheetContent.defaultProps = {
};

BalanceSheetContent.propTypes = {
  balanceSheetStepResource: PropTypes.object.isRequired,
};

export default BalanceSheetContent;
